import { frequentlyOrderRepository } from '~/api/repository/frequently-order';

export const FREQUENTLY_ORDER_QUERY_KEY = {
  all: ['frequently-order'] as const,

  // 자주 구매한 상품 목록
  products: () => ({
    queryKey: [...FREQUENTLY_ORDER_QUERY_KEY.all, 'products'] as const,
    queryFn: () => frequentlyOrderRepository.getFrequentlyOrderProducts(),
  }),
};
